export const comics = [
  {
    id: 'secret-class',
    title: '秘密教学',
    author: '作家Yoon',
    category: 'love',
    categoryName: '恋爱',
    coverSeq: 'comic-cover-01',
    coverDesc: 'Secret Class Korean manga cover art illustration with soft romantic atmosphere warm lighting elegant composition',
    status: '连载中',
    rating: 9.6,
    description: '从小失去父母被收养的少女，在成长过程中与身边人发生的一系列温馨又刺激的故事。精致画风和细腻情感描写让这部作品成为韩漫中的经典之作。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 新的开始', date: '2026-07-03' },
      { id: 'ch-2', title: '第2话 - 意外的相遇', date: '2026-07-02' },
      { id: 'ch-3', title: '第3话 - 心跳加速', date: '2026-07-01' },
      { id: 'ch-4', title: '第4话 - 无法言说的秘密', date: '2026-06-30' },
      { id: 'ch-5', title: '第5话 - 深夜的访客', date: '2026-06-29' },
      { id: 'ch-6', title: '第6话 - 心动的瞬间', date: '2026-06-28' },
    ],
    tags: ['恋爱', '校园', '甜蜜'],
    views: 1280000,
    isHot: true,
    isNew: false,
    slug: 'secret-class',
  },
  {
    id: 'demon-king',
    title: '魔王归来',
    author: '作家Kim',
    category: 'fantasy',
    categoryName: '奇幻',
    coverSeq: 'comic-cover-02',
    coverDesc: 'Demon King Returns Korean manga cover dramatic fantasy scene dark atmosphere powerful character illustration',
    status: '连载中',
    rating: 9.8,
    description: '曾经统治魔界的魔王在一次叛乱中被封印，千年后意外苏醒却发现世界已经大变。为了重新找回自己的力量，他踏上了一段充满冒险的奇幻之旅。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 千年苏醒', date: '2026-07-03' },
      { id: 'ch-2', title: '第2话 - 陌生的世界', date: '2026-07-01' },
      { id: 'ch-3', title: '第3话 - 力量的追寻', date: '2026-06-29' },
      { id: 'ch-4', title: '第4话 - 新的伙伴', date: '2026-06-27' },
      { id: 'ch-5', title: '第5话 - 宿敌现身', date: '2026-06-25' },
    ],
    tags: ['奇幻', '冒险', '战斗'],
    views: 2150000,
    isHot: true,
    isNew: false,
    slug: 'demon-king',
  },
  {
    id: 'love-signal',
    title: '恋爱信号',
    author: '作家Park',
    category: 'love',
    categoryName: '恋爱',
    coverSeq: 'comic-cover-03',
    coverDesc: 'Love Signal Korean romance manga cover sweet couple illustration pastel colors dreamy atmosphere',
    status: '已完结',
    rating: 9.4,
    description: '两个互不相识的人在社交软件上意外匹配，从线上聊天到线下见面，一段甜蜜又真实的都市恋爱故事由此展开。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 匹配成功', date: '2026-06-20' },
      { id: 'ch-2', title: '第2话 - 第一次聊天', date: '2026-06-18' },
      { id: 'ch-3', title: '第3话 - 决定见面', date: '2026-06-15' },
      { id: 'ch-4', title: '第4话 - 初次约会', date: '2026-06-12' },
      { id: 'ch-5', title: '第5话 - 心动的感觉', date: '2026-06-10' },
      { id: 'ch-6', title: '第6话 - 最终话', date: '2026-06-08' },
    ],
    tags: ['恋爱', '都市', '甜蜜'],
    views: 980000,
    isHot: false,
    isNew: false,
    slug: 'love-signal',
  },
  {
    id: 'dark-detective',
    title: '暗夜侦探',
    author: '作家Lee',
    category: 'suspense',
    categoryName: '悬疑',
    coverSeq: 'comic-cover-04',
    coverDesc: 'Dark Detective Korean manga mystery noir cover atmospheric dark city street detective silhouette illustration',
    status: '连载中',
    rating: 9.5,
    description: '一位私家侦探接手了一桩看似普通的失踪案，却意外揭开了一个庞大的地下犯罪网络。每一个线索都指向更大的阴谋。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 失踪案件', date: '2026-07-02' },
      { id: 'ch-2', title: '第2话 - 第一个线索', date: '2026-06-30' },
      { id: 'ch-3', title: '第3话 - 地下世界', date: '2026-06-28' },
      { id: 'ch-4', title: '第4话 - 真相浮现', date: '2026-06-26' },
    ],
    tags: ['悬疑', '推理', '犯罪'],
    views: 1560000,
    isHot: true,
    isNew: false,
    slug: 'dark-detective',
  },
  {
    id: 'action-hero',
    title: '格斗天王',
    author: '作家Choi',
    category: 'action',
    categoryName: '动作',
    coverSeq: 'comic-cover-05',
    coverDesc: 'Fighting King Korean action manga cover dynamic martial arts scene powerful character intense battle illustration',
    status: '连载中',
    rating: 9.3,
    description: '曾经的地下格斗冠军隐退后在一所高中当体育老师，当学生们遭遇欺凌时，他不得不重新拾起拳套，用实力守护正义。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 隐退的冠军', date: '2026-07-02' },
      { id: 'ch-2', title: '第2话 - 校园风波', date: '2026-06-29' },
      { id: 'ch-3', title: '第3话 - 重出江湖', date: '2026-06-26' },
      { id: 'ch-4', title: '第4话 - 擂台之上', date: '2026-06-23' },
      { id: 'ch-5', title: '第5话 - 宿命对决', date: '2026-06-20' },
    ],
    tags: ['动作', '格斗', '热血'],
    views: 1890000,
    isHot: true,
    isNew: true,
    slug: 'action-hero',
  },
  {
    id: 'star-romance',
    title: '星光之恋',
    author: '作家Jung',
    category: 'love',
    categoryName: '恋爱',
    coverSeq: 'comic-cover-06',
    coverDesc: 'Star Romance Korean manga cover beautiful couple under starry night sky romantic dreamy atmosphere soft colors',
    status: '连载中',
    rating: 9.7,
    description: '顶级偶像与普通大学生的意外邂逅，在镁光灯背后的秘密恋爱。当爱情遇上舆论压力，他们能否守护这份珍贵的感情？',
    chapters: [
      { id: 'ch-1', title: '第1话 - 意外邂逅', date: '2026-07-03' },
      { id: 'ch-2', title: '第2话 - 秘密开始', date: '2026-07-01' },
      { id: 'ch-3', title: '第3话 - 危机来临', date: '2026-06-28' },
      { id: 'ch-4', title: '第4话 - 坚定选择', date: '2026-06-25' },
    ],
    tags: ['恋爱', '偶像', '娱乐圈'],
    views: 2340000,
    isHot: true,
    isNew: true,
    slug: 'star-romance',
  },
  {
    id: 'fantasy-world',
    title: '异世界转生记',
    author: '作家Han',
    category: 'fantasy',
    categoryName: '奇幻',
    coverSeq: 'comic-cover-07',
    coverDesc: 'Isekai Reincarnation Korean fantasy manga cover magical world portal adventure colorful vibrant illustration',
    status: '连载中',
    rating: 9.2,
    description: '普通上班族在意外事故后来到一个魔法世界，凭借现代知识在异世界开创属于自己的传奇。奇幻冒险与搞笑日常的完美结合。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 转生', date: '2026-07-02' },
      { id: 'ch-2', title: '第2话 - 魔法学院', date: '2026-06-30' },
      { id: 'ch-3', title: '第3话 - 首次任务', date: '2026-06-27' },
      { id: 'ch-4', title: '第4话 - 隐藏的力量', date: '2026-06-24' },
      { id: 'ch-5', title: '第5话 - 同伴集结', date: '2026-06-21' },
    ],
    tags: ['奇幻', '冒险', '搞笑'],
    views: 1670000,
    isHot: false,
    isNew: true,
    slug: 'fantasy-world',
  },
  {
    id: 'mystery-house',
    title: '诡宅',
    author: '作家Seo',
    category: 'suspense',
    categoryName: '悬疑',
    coverSeq: 'comic-cover-08',
    coverDesc: 'Mystery House Korean horror suspense manga cover eerie mansion dark atmosphere chilling thriller illustration',
    status: '已完结',
    rating: 9.6,
    description: '一家人搬进一栋价格异常便宜的老宅后，接连发生诡异事件。看似普通的房子里隐藏着令人毛骨悚然的秘密。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 新家', date: '2026-06-15' },
      { id: 'ch-2', title: '第2话 - 奇怪的声音', date: '2026-06-12' },
      { id: 'ch-3', title: '第3话 - 地下室', date: '2026-06-09' },
      { id: 'ch-4', title: '第4话 - 真相', date: '2026-06-06' },
      { id: 'ch-5', title: '第5话 - 最终话', date: '2026-06-03' },
    ],
    tags: ['悬疑', '恐怖', '惊悚'],
    views: 1450000,
    isHot: false,
    isNew: false,
    slug: 'mystery-house',
  },
  {
    id: 'school-fight',
    title: '校园风云',
    author: '作家Kang',
    category: 'action',
    categoryName: '动作',
    coverSeq: 'comic-cover-09',
    coverDesc: 'School Fight Korean action manga cover students battle scene dynamic schoolyard setting energetic illustration',
    status: '连载中',
    rating: 9.1,
    description: '转学生来到一所校风混乱的高中，凭借过人的格斗技巧一步步整顿校园秩序，成为所有人敬畏的存在。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 转校生', date: '2026-07-01' },
      { id: 'ch-2', title: '第2话 - 立威', date: '2026-06-28' },
      { id: 'ch-3', title: '第3话 - 强敌出现', date: '2026-06-25' },
      { id: 'ch-4', title: '第4话 - 联盟', date: '2026-06-22' },
    ],
    tags: ['动作', '校园', '热血'],
    views: 1120000,
    isHot: false,
    isNew: true,
    slug: 'school-fight',
  },
  {
    id: 'office-romance',
    title: '办公室恋情',
    author: '作家Moon',
    category: 'love',
    categoryName: '恋爱',
    coverSeq: 'comic-cover-10',
    coverDesc: 'Office Romance Korean manga cover elegant workplace setting professional couple romantic tension sophisticated illustration',
    status: '已完结',
    rating: 9.3,
    description: '公司里最优秀的两位员工从竞争对手变成恋人的故事。白天是职场精英，夜晚是甜蜜恋人，这种双面生活能持续多久？',
    chapters: [
      { id: 'ch-1', title: '第1话 - 竞争对手', date: '2026-06-10' },
      { id: 'ch-2', title: '第2话 - 加班之夜', date: '2026-06-07' },
      { id: 'ch-3', title: '第3话 - 微妙变化', date: '2026-06-04' },
      { id: 'ch-4', title: '第4话 - 表白', date: '2026-06-01' },
      { id: 'ch-5', title: '第5话 - 最终话', date: '2026-05-28' },
    ],
    tags: ['恋爱', '职场', '成熟'],
    views: 890000,
    isHot: false,
    isNew: false,
    slug: 'office-romance',
  },
  {
    id: 'magic-academy',
    title: '魔法学院优等生',
    author: '作家Shin',
    category: 'fantasy',
    categoryName: '奇幻',
    coverSeq: 'comic-cover-11',
    coverDesc: 'Magic Academy Korean fantasy manga cover grand magical school students casting spells enchanting atmosphere illustration',
    status: '连载中',
    rating: 9.5,
    description: '出身平凡却拥有罕见魔法天赋的少年进入全国最顶尖的魔法学院，在竞争与友情中不断成长，揭开学院隐藏的古老秘密。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 入学通知书', date: '2026-07-03' },
      { id: 'ch-2', title: '第2话 - 魔法测试', date: '2026-06-30' },
      { id: 'ch-3', title: '第3话 - 学院生活', date: '2026-06-27' },
      { id: 'ch-4', title: '第4话 - 地下迷宫', date: '2026-06-24' },
      { id: 'ch-5', title: '第5话 - 古老传说', date: '2026-06-21' },
    ],
    tags: ['奇幻', '校园', '魔法'],
    views: 1780000,
    isHot: true,
    isNew: false,
    slug: 'magic-academy',
  },
  {
    id: 'crime-city',
    title: '罪恶都市',
    author: '作家Yoo',
    category: 'suspense',
    categoryName: '悬疑',
    coverSeq: 'comic-cover-12',
    coverDesc: 'Crime City Korean noir suspense manga cover dark urban landscape gritty crime scene intense thriller illustration',
    status: '连载中',
    rating: 9.4,
    description: '卧底警察在犯罪组织中潜伏多年，当他准备收网时却发现警局内部也存在内鬼。信任与背叛交织的黑暗都市悬疑巨作。',
    chapters: [
      { id: 'ch-1', title: '第1话 - 卧底', date: '2026-07-01' },
      { id: 'ch-2', title: '第2话 - 交易', date: '2026-06-28' },
      { id: 'ch-3', title: '第3话 - 内鬼', date: '2026-06-25' },
      { id: 'ch-4', title: '第4话 - 追捕', date: '2026-06-22' },
    ],
    tags: ['悬疑', '犯罪', '警匪'],
    views: 1340000,
    isHot: false,
    isNew: false,
    slug: 'crime-city',
  },
];

export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', count: 45 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 38 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 32 },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', count: 28 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 22 },
  { slug: 'thriller', name: '惊悚', icon: 'ri-ghost-line', count: 18 },
];

export const hotComics = comics.filter(c => c.isHot);
export const newComics = comics.filter(c => c.isNew);
export const completedComics = comics.filter(c => c.status === '已完结');
export const ongoingComics = comics.filter(c => c.status === '连载中');

export const categoryComics: Record<string, typeof comics> = {
  love: comics.filter(c => c.category === 'love'),
  fantasy: comics.filter(c => c.category === 'fantasy'),
  action: comics.filter(c => c.category === 'action'),
  suspense: comics.filter(c => c.category === 'suspense'),
};

export const reviews = [
  {
    id: 'r1',
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20professional%20headshot%20soft%20natural%20lighting%20simple%20white%20background%20editorial%20style&width=80&height=80&seq=review-avatar-01&orientation=squarish',
    role: '漫画爱好者',
    content: '韩国漫画网的阅读体验真的太棒了！下拉式阅读模式让看漫画变得特别流畅，不用频繁点击翻页，一口气能看完一整话。画质也很清晰，推荐给所有韩漫迷！',
    rating: 5,
  },
  {
    id: 'r2',
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20casual%20style%20friendly%20smile%20simple%20white%20background%20clean%20headshot&width=80&height=80&seq=review-avatar-02&orientation=squarish',
    role: '资深读者',
    content: '收藏了韩国漫画网好几个月了，更新速度真的很快，基本上韩国那边更新没多久这边就能看到了。而且分类很清晰，找漫画特别方便。',
    rating: 5,
  },
  {
    id: 'r3',
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20glasses%20cute%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=review-avatar-03&orientation=squarish',
    role: '韩漫迷',
    content: '画质超好，加载也快，最重要的是完全免费！以前在其他平台看漫画总是各种广告弹窗，韩国漫画网的阅读界面干净清爽，体验满分。',
    rating: 5,
  },
  {
    id: 'r4',
    name: '大刘',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20friendly%20expression%20headshot%20simple%20background%20professional%20portrait&width=80&height=80&seq=review-avatar-04&orientation=squarish',
    role: '漫画创作者',
    content: '作为一个漫画创作者，我很欣赏韩国漫画网对作品版权的尊重和对读者体验的重视。下拉式阅读的设计让漫画的叙事节奏得到了最好的呈现。',
    rating: 5,
  },
  {
    id: 'r5',
    name: '小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20bright%20smile%20headshot%20natural%20lighting%20simple%20white%20background%20editorial%20portrait&width=80&height=80&seq=review-avatar-05&orientation=squarish',
    role: '学生读者',
    content: '每天放学回家第一件事就是打开韩国漫画网看最新更新的漫画！恋爱类的韩漫画风都特别美，剧情也很吸引人，完全停不下来。',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '韩国漫画网的漫画都是免费的吗？',
    answer: '是的，韩国漫画网上所有漫画内容均免费提供。我们致力于为广大韩漫爱好者提供免费下拉式阅读体验，无需付费即可畅览全部漫画全集。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是一种专为手机和网页优化的漫画阅读方式。读者无需点击翻页按钮，只需向下滑动即可无缝阅读整话漫画，让阅读体验更加流畅自然。',
  },
  {
    question: '韩国漫画网的更新频率是怎样的？',
    answer: '我们紧跟韩国原版更新节奏，大部分热门连载漫画会在原版更新后的24-48小时内同步上线中文翻译版本，确保读者能第一时间看到最新内容。',
  },
  {
    question: '如何在韩国漫画网找到想看的漫画？',
    answer: '您可以通过首页的热门推荐、分类浏览（恋爱、奇幻、动作、悬疑等类型）或使用搜索功能来找到感兴趣的漫画。每部漫画都有详细的标签和简介帮助您快速了解。',
  },
  {
    question: '韩国漫画网支持手机阅读吗？',
    answer: '完全支持！韩国漫画网采用响应式设计，在手机、平板和电脑上都能获得优质的阅读体验。下拉式阅读模式在手机上的体验尤为流畅。',
  },
];